import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './click-outside.directive';
import { ClickStopPropagationDirective } from './click-stop-propagation.directive';
import { DisabledControlDirective } from './disabled-control.directive';

const DIRECTIVES = [ClickOutsideDirective, DisabledControlDirective, ClickStopPropagationDirective];
@NgModule({
  declarations: [...DIRECTIVES],
  imports: [CommonModule],
  exports: [...DIRECTIVES],
})
export class DirectivesModule {}
